import { GasFeeRepository } from "repositroy/GasFeeRepository";

// Admin credentials - moved to secure backend handling
const ADMIN_CREDENTIALS = {
  userName: "",
  password: "",
};

const ensureAdminLogin = async () => {
  if (GasFeeRepository.hasAdminToken()) {
    return true;
  }

  try {
    await GasFeeRepository.adminLogin(ADMIN_CREDENTIALS);
    return true;
  } catch (error) {
    console.error("Admin login failed:", error);
    throw new Error("Admin authentication failed");
  }
};

export const getGasFeeBalance = (onComplete = () => {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GAS_FEE_BALANCE_REQUEST" });

      // Ensure admin is logged in before making the API call
      await ensureAdminLogin();

      const response = await GasFeeRepository.getBalance();
      const data = response.data || {};
      const balance = data.balance || data.amount || 0;
      const estimatedTransactions =
        data.estimatedTransactions || data.estimated_transactions || 0;

      const processedData = {
        ...data,
        balance,
        estimatedTransactions,
      };

      dispatch({
        type: "GAS_FEE_BALANCE_SUCCESS",
        payload: processedData,
      });

      dispatch({ type: "GAS_FEE_BALANCE_REQUEST_END" });
      onComplete(processedData);
    } catch (error) {
      console.error("getGasFeeBalance error:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to fetch balance";

      dispatch({
        type: "GAS_FEE_BALANCE_FAIL",
        payload: errorMessage,
      });

      dispatch({ type: "GAS_FEE_BALANCE_REQUEST_END" });
      onComplete(null, error);
    }
  };
};

export const topUpWallet = (onComplete = () => {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "TOP_UP_WALLET_REQUEST" });

      // Ensure admin is logged in before making the API call
      await ensureAdminLogin();

      const response = await GasFeeRepository.topUpWallet();
      const data = response.data || {};
      const processedData = {
        ...data,
        timestamp: new Date().toISOString(),
      };

      dispatch({
        type: "TOP_UP_WALLET_SUCCESS",
        payload: processedData,
      });

      dispatch({ type: "TOP_UP_WALLET_REQUEST_END" });
      onComplete(processedData);
    } catch (error) {
      console.error("topUpWallet error:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to top up wallet";

      dispatch({
        type: "TOP_UP_WALLET_FAIL",
        payload: errorMessage,
      });

      dispatch({ type: "TOP_UP_WALLET_REQUEST_END" });
      onComplete(null, error);
    }
  };
};

export const refreshAdminToken = () => {
  return async (dispatch) => {
    try {
      await GasFeeRepository.refreshToken();
      return true;
    } catch (error) {
      console.error("Manual token refresh failed:", error);
      try {
        await GasFeeRepository.adminLogin(ADMIN_CREDENTIALS);
        return true;
      } catch (loginError) {
        console.error("Re-login also failed:", loginError);
        throw new Error("Token refresh and re-login failed");
      }
    }
  };
};

export const clearGasFeeErrors = () => ({
  type: "CLEAR_GAS_FEE_ERRORS",
});
